import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Yii } from "libraries/interfaces/Yii";

export interface IModalLinkData {
  type: ELinkType;
  url: string;
}

export enum ELinkType {
  img = "img",
  page = "page"
}

@Component({
  selector: 'modal-link',
  template: `
    <div *ngIf="data.type === type.img" class="topImage">
      <img  [src]="data.url | safe" alt="logo" class="limitedImage">
    </div>
    <div *ngIf="data.type === type.page" class="top">
      <btn class="closeBtn"
           [label]="labelOpenInTab"
           (onClick)="openInTab()"
           type="actionMore"
      ></btn>
      <iframe class="iframe" [src]="data.url | safe"></iframe>
    </div>
    
  `,
  styles: [`
    .topImage {
      margin: auto;
      width: fit-content;
      height: fit-content;
      max-width: 600px;
      max-height: 600px;
      z-index: 100;
      -webkit-box-shadow: 0px 0px 40px 10px rgba(0,0,0,0.5);
      box-shadow: 0px 0px 40px 10px rgba(0,0,0,0.5);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: white;
    }

    .limitedImage {
      max-width: 100%;
      max-height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    .iframe {
      width: 100%;
      height: 100%;
    }
    
    .top {
      height: 100%;
      overflow: hidden;
    }
    
    .closeBtn {
       position: absolute;
     }

  `]
})
export class ModalLinkComponent implements OnInit {

  public type: typeof ELinkType = ELinkType;
  public labelOpenInTab: string = Yii.t('wui-shared-js', 'Ouvrir dans un nouvel onglet');

  constructor(
      public dialogRef: MatDialogRef<ModalLinkComponent>,
      @Inject(MAT_DIALOG_DATA) public data: IModalLinkData,) { }
  public ngOnInit(): void {

  }

  public openInTab(): void {
    window.open(this.data.url, '_blank').focus();
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

}
